import React from 'react';
import { Line } from 'react-chartjs-2';
import '../../utils/charts';

interface AreaChartDataset {
  label: string;
  data: number[];
  backgroundColor?: string;
  borderColor?: string;
}

interface AreaChartProps {
  labels: string[];
  datasets: AreaChartDataset[];
  options?: any;
}

const AreaChart: React.FC<AreaChartProps> = ({ labels, datasets, options }) => {
  const data = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      fill: true,
      tension: 0.4,
      pointRadius: 3,
      pointHoverRadius: 5,
      backgroundColor: dataset.backgroundColor || 'rgba(57, 106, 84, 0.18)',
      borderColor: dataset.borderColor || 'rgba(57, 106, 84, 1)',
      borderWidth: 2,
    })),
  };

  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      y: { beginAtZero: true, grid: { color: 'rgba(0,0,0,0.04)' } },
      x: { grid: { display: false } },
    },
  };

  return <Line data={data} options={options || defaultOptions} />;
};

export default AreaChart;
